import { tableData } from "../constants";
import { useMemo } from "react";
import {
  ColumnDef,
  getCoreRowModel,
  useReactTable
} from "@tanstack/react-table";
import { Table } from "shared/app/Table";

export const CustomTable = () => {
  const columns = useMemo(() => {
    return [
      {
        accessorKey: "startingScore",
        header: "Starting score",
        cell: (p) => (
          <p className="text-sm font-medium text-content-1000">
            {p.getValue()}
          </p>
        ),
        footer: () => (
          <p className="text-base font-bold text-content-500">Total</p>
        )
      },
      {
        accessorKey: "renters",
        header: "Renters",
        cell: (p) => <p className="text-sm text-content-500">{p.getValue()}</p>,
        footer: () => (
          <p className="text-base font-bold text-content-500">
            {tableData[5]?.renters}
          </p>
        )
      },
      {
        accessorKey: "initialCreditScore",
        header: "Initial credit score",
        cell: (p) => <p className="text-sm text-content-500">{p.getValue()}</p>,
        footer: () => (
          <p className="text-base font-bold text-content-500">
            {tableData[5]?.initialCreditScore}
          </p>
        )
      },
      {
        accessorKey: "1 month",
        header: "1 month",
        cell: (p) => <p className="text-sm text-content-500">{p.getValue()}</p>,
        footer: () => (
          <p className="text-base font-bold text-content-500">
            {tableData[5]?.["1 month"]}
          </p>
        )
      },
      {
        accessorKey: "2 months",
        header: "2 months",
        cell: (p) => <p className="text-sm text-content-500">{p.getValue()}</p>,
        footer: () => (
          <p className="text-base font-bold text-content-500">
            {tableData[5]?.["2 months"]}
          </p>
        )
      },
      {
        accessorKey: "3 months",
        header: "3 months",
        cell: (p) => <p className="text-sm text-content-500">{p.getValue()}</p>,
        footer: () => (
          <p className="text-base font-bold text-content-500">
            {tableData[5]?.["3 months"]}
          </p>
        )
      },
      {
        accessorKey: "4 months",
        header: "4 months",
        cell: (p) => <p className="text-sm text-content-500">{p.getValue()}</p>,
        footer: () => (
          <p className="text-base font-bold text-content-500">
            {tableData[5]?.["4 months"]}
          </p>
        )
      },
      {
        accessorKey: "5 months",
        header: "5 months",
        cell: (p) => <p className="text-sm text-content-500">{p.getValue()}</p>,
        footer: () => (
          <p className="text-base font-bold text-content-500">
            {tableData[5]?.["5 months"]}
          </p>
        )
      },
      {
        accessorKey: "6 months",
        header: "6 months",
        cell: (p) => <p className="text-sm text-content-500">{p.getValue()}</p>,
        footer: () => (
          <p className="text-base font-bold text-content-500">
            {tableData[5]?.["6 months"]}
          </p>
        )
      }
    ];
  }, []);

  const table = useReactTable({
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    data: tableData || [],
    columns: columns as ColumnDef<any, any>[],
    getCoreRowModel: getCoreRowModel()
  });
  return <Table table={table} thClassName="bg-alpha-40" />;
};
